export class StyleAndTrimReq{
    style : string[]
    itemId : number
}